// Shared successCriteria evaluator. Pure Node, no browser globals.
// Production Flow classes and the upcoming bluux-sim both import from here so
// success/failure decisions stay in lockstep.

'use strict';

const helloFriend = require('./helloFriend');
const magicShow = require('./magicShow');
const surpriseParty = require('./surpriseParty');
const myStorybook = require('./myStorybook');
const bugBand = require('./bugBand');
const moonwalkMachine = require('./moonwalkMachine');
const treasureMap = require('./treasureMap');
const makeCatDance = require('./makeCatDance');

const EVALUATORS = {
    helloFriend,
    magicShow,
    surpriseParty,
    myStorybook,
    bugBand,
    moonwalkMachine,
    treasureMap,
    makeCatDance
};

// activityData.activityId values used in web/activities/**/*.json → evaluator key.
const ACTIVITY_ID_ALIASES = {
    'hello-friend': 'helloFriend',
    'magic-show': 'magicShow',
    'surprise-party': 'surpriseParty',
    'my-storybook': 'myStorybook',
    'bug-band-concert': 'bugBand',
    'bluux-moonwalk': 'moonwalkMachine',
    'treasure-map': 'treasureMap',
    'slide-right-cat': 'makeCatDance'
};

function resolveEvaluator (activityData) {
    if (!activityData || typeof activityData !== 'object') {
        return null;
    }
    const id = activityData.activityId;
    if (typeof id === 'string') {
        if (EVALUATORS[id]) {
            return EVALUATORS[id];
        }
        const alias = ACTIVITY_ID_ALIASES[id];
        if (alias && EVALUATORS[alias]) {
            return EVALUATORS[alias];
        }
    }
    return null;
}

function evaluateSuccessCriteria (activityData, simState) {
    const evaluator = resolveEvaluator(activityData);
    if (!evaluator) {
        return {success: false, reason: 'no-evaluator'};
    }
    return evaluator(activityData, simState);
}

module.exports = {
    evaluateSuccessCriteria,
    evaluators: EVALUATORS,
    activityIdAliases: ACTIVITY_ID_ALIASES
};
